import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toMiles'
})
export class ToMilesPipe implements PipeTransform {

  transform(value: number): number {
    return value * 0.621371;
  }

}



// WEBPACK FOOTER //
// ./src/app/common/pipes/toMiles.pipe.ts